import { loadHotJarTracking } from './hotJarLoader';
import _ from 'lodash';

export function redirectToInternalLink(url, checkStartWithSlash = true) {
  console.log(`redirecting to ${url}`);
  var history = window.globalHistory(); //as RR v4 does not give us history object, we get the static object defined earlier

  //with RR v4, if url does not contain '/' the router is not picking. added an extra flag checkStartWithSlash so if someone does not want to add slash in start, pass it as false
  if (checkStartWithSlash && !url.startsWith('/')) url = '/' + url;

  if (window.APP.CONFIGURATION.HASH_HISTORY == true) {
    history.push(url);
  } else if (window.APP.CONFIGURATION.HASH_HISTORY == false) {
    history.push(url);
  }

  if (window.APP.CONFIGURATION.HOTJAR_SITE_ID) {
    loadHotJarTracking(window.APP.CONFIGURATION.HOTJAR_SITE_ID);
  }
}

// Redirect to external link (leave VCM)
//Only be called for urls as the return url in URL (query string)
export function redirectToExternalLink(url, avoidBrowserCache = true) {
  console.log(`redirecting to external link - ${url}`);

  if (avoidBrowserCache) {
    // use a modified url instead to avoid the browser cache
    const cacheControlToken = _.random(1000);
    if (url.includes('?')) {
      url += '&loginid=' + cacheControlToken;
    } else {
      url += '?loginid=' + cacheControlToken;
    }
  }
  if (url) {
    //We want to test if the redirect url to external site is not out of our domain
    //This function is called only for the url as the return url
    try {
      var completeURL = new URL(url); //create the url object
      if (completeURL.hostname.toLowerCase() != window.location.hostname.toLocaleLowerCase()) {
        //if they dont match redirect to home page
        window.location.href = window.location.origin;
        return;
      }
    } catch (ex) {
      //don't want to do anything. safety check so execution does not break;
    }
  }
  window.location.href = url;
}

export function currentPage() {
  if (window.APP.CONFIGURATION.HASH_HISTORY == true) {
    return window.location.hash.substring(1, window.location.hash.length).split('?')[0];
  } else if (window.APP.CONFIGURATION.HASH_HISTORY == false) {
    return window.location.pathname;
  }
}
